<template>
	<div v-on-click-outside="closeSelectorDropdown" class="relative">
		<button
			class="btn btn-secondary btn-lg flex justify-between w-full text-body-primary font-normal typo-body-caption pr-3"
			@click="roggleSelectorDropdownVisible()"
		>
			{{ selectedName }}
			<NuxtIcon
				name="chevron-down"
				filled
				class="text-2xl text-icon-primary transition ease"
				:class="{'rotate-180': isSelectorDropdownVisible}"
			/>
		</button>

		<Transition name="fade">
			<div
				v-if="isSelectorDropdownVisible"
				class="absolute z-20 px-6 w-full top-[calc(100%+0.5rem)] left-0 overflow-auto bg-white border border-border-tertiary rounded-[.625rem] shadow-md typo-body-caption overflow-y-auto max-h-[10rem]"
			>
				<ul class="divide-y divide-border-secondary">
					<li v-for="l in list" :key="l.ID">
						<button
							type="button"
							class="group/link flex items-center gap-x-2 h-12 cursor-pointer"
							:class="{'text-body-important font-semibold !cursor-default': activeId === l.ID}"
							@click="changeActiveId(l.ID)"
						>
							<NuxtIcon
								v-if="activeId === l.ID"
								name="check"
								class="text-xs text-icon-primary"
								filled
							/>
							<span>{{ l.Name }}</span>
						</button>
					</li>
				</ul>
			</div>
		</Transition>
	</div>
</template>

<script setup lang="ts">
	import {vOnClickOutside} from '@vueuse/components';
	import {set} from '@vueuse/core';
	import type {Gsoa_ShoppingList_GetAllShoppingListsCollection as BasicShoppingList} from '~/openapi';

	interface Props {
		list?: BasicShoppingList[]
		activeId: number | null
	}

	interface Emits {
		(e: 'confirm', id: number): void
	}

	const props = defineProps<Props>();
	const emit = defineEmits<Emits>();
	const [isSelectorDropdownVisible, roggleSelectorDropdownVisible] = useToggle();
	const selectedName = computed(() => {
		const activeItem = props.list?.find((item) => item.ID === props.activeId);
		return activeItem ? activeItem.Name : null;
	});

	function closeSelectorDropdown() {
		set(isSelectorDropdownVisible, false);
	}
	function changeActiveId(id: number) {
		emit('confirm', id);
		closeSelectorDropdown();
	}
</script>
